export default __webpack_public_path__ + "static/img/share.07b4f96.jpg";